import { Grid, styled, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MultiDayDayBlockPreviewFieldsProps } from './multi-day-day-block-preview-fields.types';
import { formatMultiDayBlockPreviewTime } from '../helpers/multi-day-day-block.helpers';

export const MultiDayDayBlockPreviewFields = ({
  breakLabel,
  endTime,
  index,
  startTime,
}: MultiDayDayBlockPreviewFieldsProps) => {
  const { t } = useTranslation('web-common');

  return (
    <Grid columnSpacing={4} container data-testid={`multi-day-day-block-${index}-preview-fields`}>
      <Grid item xs={4}>
        <PreviewField
          label={t('work_form.multi_day.day_blocks.start_time.label')}
          testId={`multi-day-day-block-${index}-preview-start-time`}
          value={formatMultiDayBlockPreviewTime(startTime)}
        />
      </Grid>
      <Grid item xs={4}>
        <PreviewField
          label={t('work_form.multi_day.day_blocks.end_time.label')}
          testId={`multi-day-day-block-${index}-preview-end-time`}
          value={formatMultiDayBlockPreviewTime(endTime)}
        />
      </Grid>
      <Grid item xs={4}>
        <PreviewField
          label={t('work_form.multi_day.day_blocks.break.label')}
          testId={`multi-day-day-block-${index}-preview-break`}
          value={breakLabel}
        />
      </Grid>
    </Grid>
  );
};

const PreviewField = ({
  label,
  testId,
  value,
}: {
  label: string;
  testId: string;
  value: string;
}) => (
  <PreviewFieldContainer>
    <PreviewLabel variant="body2">
      {label}
      <RequiredMark aria-hidden>*</RequiredMark>
    </PreviewLabel>
    <PreviewValue data-testid={testId} variant="body1">
      {value}
    </PreviewValue>
  </PreviewFieldContainer>
);

const PreviewFieldContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

const PreviewLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const RequiredMark = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginLeft: theme.spacing(0.5),
}));

const PreviewValue = styled(Typography)({
  fontWeight: 600,
});
